<!-- Modal Backdrop -->
<div
  class="modal fade"
  [class.show]="isOpen()"
  [style.display]="isOpen() ? 'block' : 'none'"
  tabindex="-1"
  role="dialog"
  aria-modal="true"
  aria-labelledby="quickScheduleModalTitle"
  (click)="onBackdropClick($event)"
  (keydown)="onKeydown($event)"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">
        <h5 class="modal-title d-flex align-items-center gap-2" id="quickScheduleModalTitle">
          <i class="bi bi-calendar-plus"></i>
          Schedule Flight
        </h5>
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="close()"
          [disabled]="isProcessing()"
        ></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body">
        <!-- Loading Overlay -->
        <div *ngIf="loadingOptions()" class="text-center py-4">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <p class="mt-2 text-muted">Loading form options...</p>
        </div>

        <!-- Form -->
        <form *ngIf="!loadingOptions()" (ngSubmit)="onSave()">
          <div class="row g-3">
            <!-- Application Date -->
            <div class="col-md-6">
              <label for="applicationDate" class="form-label">
                Application Date <span class="text-danger">*</span>
              </label>
              <input
                type="date"
                id="applicationDate"
                class="form-control"
                [class.is-invalid]="hasError('applicationDate')"
                [value]="formData().applicationDate"
                (input)="updateField('applicationDate', $any($event.target).value)"
                [disabled]="isProcessing()"
                required
              />
              <div class="invalid-feedback" *ngIf="hasError('applicationDate')">
                {{ getError('applicationDate') }}
              </div>
            </div>

            <!-- Field -->
            <div class="col-md-6">
              <label for="fieldId" class="form-label">
                Field / Location <span class="text-danger">*</span>
              </label>
              <select
                id="fieldId"
                class="form-select"
                [class.is-invalid]="hasError('fieldId')"
                [value]="formData().fieldId"
                (change)="updateField('fieldId', $any($event.target).value)"
                [disabled]="isProcessing()"
                required
              >
                <option value="">Select a field...</option>
                <option *ngFor="let field of fields()" [value]="field.id">
                  {{ field.name }}
                  <span *ngIf="field.acreage"> ({{ field.acreage }} acres)</span>
                </option>
              </select>
              <div class="invalid-feedback" *ngIf="hasError('fieldId')">
                {{ getError('fieldId') }}
              </div>
            </div>

            <!-- Drone -->
            <div class="col-md-6">
              <label for="droneId" class="form-label">Drone Assignment</label>
              <select
                id="droneId"
                class="form-select"
                [value]="formData().droneId"
                (change)="updateField('droneId', $any($event.target).value)"
                [disabled]="isProcessing()"
              >
                <option value="">Select a drone (optional)...</option>
                <option *ngFor="let drone of drones()" [value]="drone.id">
                  {{ drone.name }}
                  <span *ngIf="drone.modelName"> - {{ drone.modelName }}</span>
                </option>
              </select>
            </div>

            <!-- Pilot -->
            <div class="col-md-6">
              <label for="pilotId" class="form-label">Pilot Assignment</label>
              <select
                id="pilotId"
                class="form-select"
                [value]="formData().pilotId"
                (change)="updateField('pilotId', $any($event.target).value)"
                [disabled]="isProcessing()"
              >
                <option value="">Select a pilot (optional)...</option>
                <option *ngFor="let pilot of pilots()" [value]="pilot.id">
                  {{ pilot.name }}
                </option>
              </select>
            </div>

            <!-- Notes -->
            <div class="col-12">
              <label for="notes" class="form-label">Notes</label>
              <textarea appCharCounter
                id="notes"
                class="form-control"
                rows="3"
                placeholder="Add any notes about this flight (optional)..."
                [value]="formData().notes"
                (input)="updateField('notes', $any($event.target).value)"
                [disabled]="isProcessing()"
              ></textarea>
            </div>
          </div>
        </form>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-secondary"
          (click)="close()"
          [disabled]="isProcessing()"
        >
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-outline-primary"
          (click)="onSaveAndContinue()"
          [disabled]="isProcessing() || loadingOptions()"
        >
          <span *ngIf="isProcessing() && saveAndContinue()" class="spinner-border spinner-border-sm me-1" role="status"></span>
          Save &amp; Continue Editing
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="onSave()"
          [disabled]="isProcessing() || loadingOptions()"
        >
          <span *ngIf="isProcessing() && !saveAndContinue()" class="spinner-border spinner-border-sm me-1" role="status"></span>
          Save
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Backdrop Overlay -->
<div
  class="modal-backdrop fade"
  [class.show]="isOpen()"
  *ngIf="isOpen()"
></div>
